import '@packlink/metrics';

let LoggerPaymentBreadcrumb = /*#__PURE__*/function (LoggerPaymentBreadcrumb) {
  LoggerPaymentBreadcrumb["PAYMENT"] = "Payment";
  return LoggerPaymentBreadcrumb;
}({});
let LoggerPaymentErrorTagValues = /*#__PURE__*/function (LoggerPaymentErrorTagValues) {
  LoggerPaymentErrorTagValues["PAYMENT_CLIENT_SETUP"] = "braintree.client.setup";
  LoggerPaymentErrorTagValues["PAYMENT_CREDIT_CARD_SETUP"] = "braintree.credit-card.setup";
  LoggerPaymentErrorTagValues["PAYMENT_CREDIT_CARD_LOOKUP"] = "braintree.credit-card.lookup";
  LoggerPaymentErrorTagValues["PAYMENT_CREDIT_CARD_VERIFICATION"] = "braintree.credit-card.verification";
  LoggerPaymentErrorTagValues["PAYMENT_CREDIT_CARD_VERIFICATION_LIABILITY"] = "braintree.credit-card.verification-liability";
  LoggerPaymentErrorTagValues["PAYMENT_PAYPAL_SETUP"] = "braintree.paypal.setup";
  LoggerPaymentErrorTagValues["PAYMENT_PAYPAL_VERIFICATION"] = "braintree.paypal.verification";
  LoggerPaymentErrorTagValues["PAYMENT_LOCAL_PAYMENT_SETUP"] = "braintree.local-payment.setup";
  LoggerPaymentErrorTagValues["PAYMENT_LOCAL_PAYMENT_VERIFICATION"] = "braintree.local-payment.verification";
  return LoggerPaymentErrorTagValues;
}({});
let LoggerPaymentContext = /*#__PURE__*/function (LoggerPaymentContext) {
  LoggerPaymentContext["PAYMENT_SETUP"] = "payment_setup";
  LoggerPaymentContext["PAYMENT_LOOKUP"] = "payment_lookup";
  LoggerPaymentContext["PAYMENT_VERIFICATION"] = "payment_verification";
  LoggerPaymentContext["PAYMENT_VERIFICATION_ERROR"] = "payment_verification_error";
  return LoggerPaymentContext;
}({});
let LoggerPaymentTag = /*#__PURE__*/function (LoggerPaymentTag) {
  LoggerPaymentTag["PAYMENT_TYPE"] = "payment.type";
  LoggerPaymentTag["PAYMENT_METHOD"] = "payment.method";
  LoggerPaymentTag["PAYMENT_ERROR"] = "payment.error";
  return LoggerPaymentTag;
}({});
let PaymentStep = /*#__PURE__*/function (PaymentStep) {
  PaymentStep["SETUP"] = "setup";
  PaymentStep["LOOKUP"] = "lookup";
  PaymentStep["VERIFICATION"] = "verification";
  return PaymentStep;
}({});
let OptionImgSize = /*#__PURE__*/function (OptionImgSize) {
  OptionImgSize["REGULAR"] = "regular";
  OptionImgSize["LARGE"] = "large";
  return OptionImgSize;
}({});

// niceType https://braintree.github.io/braintree-web/3.67.0/HostedFields.html#~hostedFieldsCard
// Also should be in public-assets -> projects/payment-cards
let SupportedCardImages = /*#__PURE__*/function (SupportedCardImages) {
  SupportedCardImages["AMERICAN EXPRESS"] = "american-express";
  SupportedCardImages["DINERS CLUB"] = "diners-club";
  SupportedCardImages["DISCOVER"] = "discover";
  SupportedCardImages["JCB"] = "jcb";
  SupportedCardImages["MAESTRO"] = "maestro";
  SupportedCardImages["MASTERCARD"] = "master-card";
  SupportedCardImages["UNIONPAY"] = "unionpay";
  SupportedCardImages["VISA"] = "visa";
  return SupportedCardImages;
}({});

export { LoggerPaymentBreadcrumb, LoggerPaymentContext, LoggerPaymentErrorTagValues, LoggerPaymentTag, OptionImgSize, PaymentStep, SupportedCardImages };
//# sourceMappingURL=types.js.map
